const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const isBlank = (value) => value === undefined || value === null || String(value).trim() === '';
const maxLength = (max) => (value) => isBlank(value) || String(value).trim().length <= max;
const requiredMaxLength = (max) => (value) => !isBlank(value) && String(value).trim().length <= max;

const contacts = {
  'Import ID': {
    requirementType: 'required',
    renamedFrom: 'ID',
    uniqueInFile: true,
    description:
      'Unique identifier for the imported contact. It must be unique within the file, and rows are also checked against previous imports. If a duplicate is found, the row will be skipped from import. Previously named "ID".',
    dataType: 'string',
    validator: requiredMaxLength(255),
  },
  'Client Name': {
    requirementType: 'optional',
    description:
      'The name of the client to associate with this contact. When provided, it must match an existing client name exactly (white space, case, and punctuation), otherwise the row will be skipped during import.',
    dataType: 'string',
    validator: maxLength(255),
  },
  'Company Name': {
    requirementType: 'optional',
    description:
      'The name of the company to associate with this contact. When provided, it must match an existing company name exactly (white space, case, and punctuation), otherwise the row will be skipped during import.',
    dataType: 'string',
    validator: maxLength(255),
  },
  'Opportunity Name': {
    requirementType: 'optional',
    description:
      'The name of the opportunity to associate with this contact. When provided, it must match an existing opportunity name exactly (white space, case, and punctuation), otherwise the row will be skipped during import.',
    dataType: 'string',
    validator: maxLength(255),
  },
  'First Name': {
    requirementType: 'required',
    description: 'First name of the contact (max 127 characters).',
    dataType: 'string',
    validator: requiredMaxLength(127),
  },
  'Last Name': {
    requirementType: 'required',
    description: 'Last name of the contact (max 127 characters).',
    dataType: 'string',
    validator: requiredMaxLength(127),
  },
  Email: {
    requirementType: 'required',
    uniqueInFile: true,
    description:
      'Email address of the contact. It must be unique within the file, and a row whose email already belongs to a contact in your workspace will be skipped during import.',
    dataType: 'email',
    validator: (value) =>
      !isBlank(value) && EMAIL_REGEX.test(String(value).trim()) && String(value).trim().length <= 255,
  },
  Title: {
    requirementType: 'optional',
    description: 'Job title or position of the contact (max 255 characters).',
    dataType: 'string',
    validator: maxLength(255),
  },
  Tags: {
    requirementType: 'optional',
    description:
      'Contact tags are used in filtering and organizing contacts into groups. This field can include one tag or be a semicolon-delimited list of tags associated with the contact (for example: "Decision Maker;Finance"). If a tag doesn\'t exist in your workspace, it will automatically be created with this import.',
    dataType: 'string',
    validator: () => true,
  },
  'Office Phone': {
    requirementType: 'optional',
    description: 'Office phone number of the contact (max 255 characters).',
    dataType: 'string',
    validator: maxLength(255),
  },
  'Mobile Phone': {
    requirementType: 'optional',
    description: 'Mobile phone number of the contact (max 255 characters).',
    dataType: 'string',
    validator: maxLength(255),
  },
  Fax: {
    requirementType: 'optional',
    description: 'Fax number of the contact (max 255 characters).',
    dataType: 'string',
    validator: maxLength(255),
  },
  'Website URL': {
    requirementType: 'optional',
    renamedFrom: 'Website Url',
    description: 'Website of the contact (max 1024 characters).',
    dataType: 'string',
    validator: maxLength(1024),
  },
  Description: {
    requirementType: 'optional',
    description: 'Notes or a description related to the contact (max 5000 characters).',
    dataType: 'string',
    validator: maxLength(5000),
  },
};

export default contacts;
